// extracted by mini-css-extract-plugin
export default {"errorMessage":"M07ZwIS3gs3WMTRgIIG5","inverse":"QpNCIgLW3O8tMAax2iSL"};